import Container from "components/general/Container";
import ScrollContainer from "components/general/ScrollContainer";
import Seo from "components/general/Seo";
import { ServiceOrderDetail } from "components/serviceOrders/ServiceOrderDetail";
import { Box, Text } from "components/ui";
import { useLocalSearchParams } from "expo-router";
import React, { useEffect } from "react";
import { ActivityIndicator } from "react-native";
import { useGetServiceOrderByIdQuery } from "store/abcoApi";

export default function Page() {
	const { id } = useLocalSearchParams<{ id: string }>();

	const {
		data: serviceOrder,
		isLoading,
		refetch,
	} = useGetServiceOrderByIdQuery({
		id: Number(id),
	});

	useEffect(() => {
		if (serviceOrder?.caseNumber === "Creating") {
			const interval = setInterval(() => {
				refetch();
			}, 2000); // 30 seconds

			return () => clearInterval(interval); // cleanup on unmount or re-render
		}
	}, [serviceOrder?.caseNumber, refetch]);

	if (isLoading) {
		return (
			<Box minHeight={"$full"} justifyContent="center" borderRadius={16}>
				<ActivityIndicator size={"large"} style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }, { translateY: 25 }] }} />
			</Box>
		);
	}

	return (
		<ScrollContainer>
			<Seo title={`Service Order ${serviceOrder?.caseNumber}`} description="" />
			<Container>
				<ServiceOrderDetail data={serviceOrder} />
			</Container>
		</ScrollContainer>
	);
}
